<template>
    <section class="sm:ut-flex sm:ut-content-start ut-items-start
      ut-block ut-py-5 md:ut-px-0 ut-px-6">
      <div class="ut-text-neutral-400 ut-mx-0 sm:ut-pr-2 sm:ut-block ut-flex
        sm:ut-my-0 ut-mb-4 prospect-details-col-1">
        <h4 class="sm:ut-inline-block ut-hidden ut-text-xs ut-mb-2">Owner</h4>
        <h4 class="sm:ut-hidden ut-text-sm ut-flex-shrink-0">Owner:</h4>
        <p class="sm:ut-text-base ut-text-sm">{{ prospectName }}</p>
      </div>
      <div class="ut-text-neutral-400 ut-mx-0 sm:ut-pr-2 sm:ut-block ut-flex sm:ut-my-0 ut-mb-4
        prospect-details-col-2">
        <h4 class="sm:ut-inline-block ut-hidden ut-text-xs ut-mb-2">Recent activity</h4>
        <h4 class="sm:ut-hidden ut-text-sm ut-flex-shrink-0">Recent activity:</h4>
        <p class="sm:ut-text-base ut-text-sm">{{ activitySummary }}</p>
      </div>
      <div class="ut-text-neutral-400 ut-mx-0 sm:ut-block ut-flex
        sm:ut-my-0 prospect-details-col-3">
        <h4 class="sm:ut-inline-block ut-hidden ut-text-xs ut-mb-2">Active</h4>
        <h4 class="sm:ut-hidden ut-text-sm ut-flex-shrink-0">Active:</h4>
        <p class="sm:ut-text-base ut-text-sm">{{ daysAgo }}</p>
      </div>
    </section>
</template>

<script>

export default {
  name: 'ProspectCardDetails',
  components: {},
  props: {
    prospectName: {
      type: String,
      required: false,
      default: null,
    },
    activitySummary: {
      type: String,
      required: false,
      default: null,
    },
    prospectDate: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    daysAgo() {
      if (this.prospectDate) {
        const prospectDate = Number(this.prospectDate);

        if (prospectDate < 1) {
          return 'Today';
        }

        if (prospectDate === 1) {
          return `${prospectDate} day ago`;
        }

        if (prospectDate > 60) {
          return 'A few months ago';
        }

        if (prospectDate >= 30) {
          return '1 month ago';
        }

        return `${prospectDate} days ago`;
      }

      return '-';
    },
  },
  watch: {},
  created() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
section {
    h4 {
      width: 141px;
      @apply ut-text-neutral-400;
    }
    p {
      @apply ut-text-neutral-400;
    }
    @screen md {
      margin-left: 72px;
    p {
        line-height: 20px;
      }
    h4 {
      width: auto;
      line-height: 20px;
    }
  }
}

@screen sm {

  .prospect-details-col-1 {
    width: 207px;
  }

  .prospect-details-col-2 {
    width: 267px;
  }

  .prospect-details-col-3 {

  }

}

</style>
